import { useEffect, useRef } from "react";

const SDK = "https://cdn.commoninja.com/sdk/latest/commonninja.js";
const WIDGET_ID = "29114558-470e-4fce-83fd-f36cd12cbe26";

// Common Ninja Google Reviews widget. The SDK loads only when the section nears the screen,
// so it never slows down the first paint; on later route changes it re-scans the page.
export const ReviewsWidget = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const load = () => {
      if (window.CommonNinja?.init) { window.CommonNinja.init(); return; }
      if (document.querySelector(`script[src="${SDK}"]`)) return;
      const s = document.createElement("script");
      s.src = SDK;
      s.defer = true;
      document.body.appendChild(s);
    };
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { io.disconnect(); load(); }
    }, { rootMargin: "600px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return <div ref={ref} className={`commonninja_component pid-${WIDGET_ID} mt-10 min-h-[320px]`} data-testid="google-reviews-widget" />;
};
